export default "__VITE_ASSET__DYZxQfsa__"